<template>
    <input-wrapper
        class="select-input"
        v-bind="{ label, state, helpText }"
    >
        <template #default="{ id }">
            <b-form-select
                v-bind="{ state, name, id, required }"
                :options="selectOptions"
                v-model="inputValue"
            />
        </template>
    </input-wrapper>
</template>

<script>
    import InputWrapper from '../InputWrapper/InputWrapper';
    import { BFormSelect } from 'bootstrap-vue';
    import InputBase from '../InputBase.mixin';

    export default {
        name: 'select-input',

        components: { InputWrapper, BFormSelect },

        mixins: [InputBase],

        props: {
            options: {
                type: Array,
                required: true,
            },
        },

        computed: {
            /**
             * Return the select options with the provided placeholder if defined.
             *
             * @returns {{text: string, value: string|number, disabled: boolean|undefined}[]}
             */
            selectOptions() {
                const options = [
                    ...this.options,
                ];

                if (this.placeholder) {
                    options.unshift({
                        text: this.placeholder,
                        value: null,
                        disabled: true,
                    });
                }

                return options;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/forms";

    ::v-deep {
        @import "~bootstrap/scss/custom-forms";
        // TODO: Dropdown icon
    }
</style>
